import { ReactElement, ReactNode, SyntheticEvent } from 'react';

import { Form, LabelProps } from '@servicetitan/design-system';

interface RadioButtonOptions<T> {
    label: string;
    description?: ReactElement | string;
    value: T;
}

interface RadioButtonGroupProps<T> {
    name: string;
    label?: string;
    labelProps?: LabelProps;
    description?: ReactNode;
    disabled?: boolean;
    value: T | undefined;
    options: RadioButtonOptions<T>[];
    error?: string;
    onChange: (event: SyntheticEvent<HTMLInputElement>, data: { value: T }) => void;
}

export const RadioButtonGroup = <T,>({
    name,
    label,
    labelProps,
    description,
    disabled,
    value,
    options,
    error,
    onChange,
}: RadioButtonGroupProps<T>) => {
    return (
        <Form.Group grouped>
            <Form.Field label={label} labelProps={labelProps} error={error}>
                {description}
                {options.map(opt => (
                    <Form.Radio
                        key={opt.label}
                        name={name}
                        label={opt.label}
                        description={opt.description}
                        checked={opt.value === value}
                        disabled={disabled}
                        value={opt.value}
                        error={!!error}
                        onChange={(newValue, event) => {
                            onChange(event, { value: newValue });
                        }}
                    />
                ))}
            </Form.Field>
        </Form.Group>
    );
};
RadioButtonGroup.displayName = 'RadioButtonGroup';
